export default class ExposureV2 {
	constructor() {
		this.minValue = -5;
		this.maxValue = 5;
		this.blockName = "ExposureV2";
		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let blockCanvasName = UI.createBlockCanvas(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);
		$(element)
			.find(".exposure_slider")
			.on("input", _ => this.exposureSliderHandler($(element)));
		$(element)
			.find(".exposure_range")
			.on("change", _ => this.exposureValueHandler($(element)));

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: this.blockName,
			version: '2',
			passes: [this.addExposurePass()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
			values: {
				exposure: 0,
			},
		});
	}

	addExposurePass() {
		let shaderPass = gpu.createLiftGammaGainPass();
		gpu.addPassToComposer(shaderPass, "toMiddle");
		return shaderPass;
	}

	exposureSliderHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let exposureValue = UI.getAdjustmentBlock_sliderValue($el);
		UI.setAdjustmentBlock_rangeValue($el, exposureValue);

		let block = lutify.getActiveBlock();
		block.values.exposure = exposureValue;
		block.passes[0].uniforms.exposure.value = exposureValue;
		gpu.render();
	}

	exposureValueHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let exposureValue = UI.getAdjustmentBlock_rangeValue($el);

		if (exposureValue > this.maxValue) {
			exposureValue = this.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, exposureValue);
		}
		if (exposureValue < this.minValue) {
			exposureValue = this.minValue;
			UI.setAdjustmentBlock_rangeValue($el, exposureValue);
		}

		UI.setAdjustmentBlock_sliderValue($el, exposureValue);
		lutify.getActiveBlock().values.exposure = exposureValue;
		lutify.getActiveBlock().passes[0].uniforms.exposure.value = exposureValue;
		gpu.render();
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes[0].uniforms.opacity.value = calcOpacityValue;

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	applyChanges($block, values, blockData) {
		UI.setAdjustmentBlock_rangeValue($block, values.exposure);
		$block.find(".exposure_range").trigger("change");

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}
	}
}
